import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconPaperPlane: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="paper-plane, send"><path d="M2.75772 5.91475C1.99138 3.9989 3.99291 2.14806 5.84305 3.06171L19.8582 9.98279C21.5299 10.8083 21.5299 13.1921 19.8582 14.0176L5.84305 20.9387C3.99292 21.8524 1.99138 20.0015 2.75772 18.0857L4.89199 12.75H9.24969C9.6639 12.75 9.99969 12.4142 9.99969 12C9.99969 11.5858 9.6639 11.25 9.24969 11.25H4.89182L2.75772 5.91475Z" fill="currentColor"/></CentralIconBase>;
};

export default IconPaperPlane;
